<script>
  import http from '@/service/http'
  import findIndex from 'lodash/findIndex'
  import {mapGetters, mapState} from 'vuex'
  import moment from 'moment'

  export default {
    name: 'Estoque',
    data () {
      return {
        list: [],
        usuarios: [],
        viaturas: [],
        busca: '',
        pagination: {
          current_page: 1,
          last_page: 1
        },
        filtro: {
          inicio: '',
          termino: '',
          operacao: '',
          usuario: '',
          viatura: '',
          os: '',
          venda: ''
        },
        show: {
          filtro: false
        }
      }
    },
    mounted () {
      this.paginate()
    },
    methods: {
      formatDate (date) {
        return moment(date).format('DD/MM/YYYY HH:mm')
      },
      async paginate (page) {
        if (page) {
          this.pagination.current_page = page
        }
        const {data} = await http.get(`/produtos/estoque?page=${this.pagination.current_page}&inicio=${this.filtro.inicio}&termino=${this.filtro.termino}&operacao=${this.filtro.operacao}&usuario=${this.filtro.usuario}&viatura=${this.filtro.viatura}&os=${this.filtro.os}&venda=${this.filtro.venda}`)
        if (data != null) {
          this.list = data.rows.data
          this.pagination.current_page = data.rows.current_page
          this.pagination.last_page = data.rows.last_page
          this.filtro = data.filtro
          this.usuarios = data.usuarios
          this.viaturas = data.viaturas
        }
      },
      async filtrar () {
        this.busca = ''
        const { data } = await http.get(`/produtos/estoque?inicio=${this.filtro.inicio}&termino=${this.filtro.termino}&operacao=${this.filtro.operacao}&usuario=${this.filtro.usuario}&viatura=${this.filtro.viatura}&os=${this.filtro.os}&venda=${this.filtro.venda}`)
        this.list = data.rows.data
        this.pagination.current_page = data.rows.current_page
        this.pagination.last_page = data.rows.last_page
        this.filtro = data.filtro
        this.usuarios = data.usuarios
        setTimeout(function () {
          window.Materialize.updateTextFields()
        }, 0)
      },
      async updateList (obj) {
        const {estoque} = obj
        const index = await findIndex(this.list, {id: estoque.id})
        if (index > -1) {
          this.list[index] = {...estoque}
        } else {
          this.list.unshift(estoque)
        }
        window.Materialize.toast('Registro salvo com sucesso!!', 4000)
      },
      submitForm () {
        $('#form-pdf').submit()
      }
    },
    computed: {
      ...mapState(['loading']),
      ...mapGetters(['permissoes']),
      showBtNovo () {
        return this.$route.name === 'estoque.index'
      },
      showBtVoltar () {
        return this.$route.name === 'estoque.form'
      },
      hasItens () {
        return this.list.length > 0
      },
      api_url () {
        return process.env.API_URL
      }
    }
  }
</script>

<template>
  <div>

    <div class="content">

      <div class="row">
        <div class="col s12 m11">
          <h5>Estoque</h5>
        </div>
<!--        <div class="input-field col s9 m4">-->
<!--          <form @submit.prevent="buscar" v-show="showBtNovo">-->
<!--            <input id="busca" type="text" v-model="busca">-->
<!--            <label for="busca">Buscar</label>-->
<!--          </form>-->
<!--        </div>-->
        <div class="col s3 m1 input-field right-align">
          <router-link :to="{ name: 'estoque.form' }" v-show="showBtNovo && permissoes.indexOf('estoque.inserir') > -1" class="btn-floating btn-large waves-effect waves-light">
            <i class="material-icons">add</i></router-link>
          <router-link :to="{ name: 'estoque.index' }" v-show="showBtVoltar" class="btn-floating btn-large waves-effect waves-light red">
            <i class="material-icons">close</i>
          </router-link>
        </div>
      </div>

      <div class="row" v-show="showBtNovo">
        <div class="col s12">
          <button class="btn-floating waves-effect waves-light" @click.prevent="show.filtro = !show.filtro"><i class="material-icons">filter_list</i></button>
        </div>
      </div>
      <form :action="`${api_url}/estoque/pdf`" method="get" id="form-pdf" target="_blank">
        <input type="hidden" name="inicio" v-model="filtro.inicio" :data-value="filtro.inicio">
        <input type="hidden" name="termino" v-model="filtro.termino" :data-value="filtro.termino">
        <input type="hidden" name="os" v-model="filtro.os" :data-value="filtro.os">
        <input type="hidden" name="venda" v-model="filtro.venda" :data-value="filtro.venda">
        <input type="hidden" name="operacao" v-model="filtro.operacao" :data-value="filtro.operacao">
        <input type="hidden" name="viatura" v-model="filtro.viatura" :data-value="filtro.viatura">
        <input type="hidden" name="usuario" v-model="filtro.usuario" :data-value="filtro.usuario">
      </form>

      <form @submit.prevent="filtrar">

        <div class="row" v-show="show.filtro && showBtNovo">

          <div class="input-field col s12 m3">
            <i class="material-icons prefix">event</i>
            <input id="icon_inicio" type="date" v-model="filtro.inicio" :data-value="filtro.inicio">
            <label for="icon_inicio" class="active">Início</label>
          </div>

          <div class="input-field col s12 m3">
            <i class="material-icons prefix">event</i>
            <input id="icon_termino" type="date" v-model="filtro.termino" :data-value="filtro.termino">
            <label for="icon_termino" class="active">Término</label>
          </div>

          <div class="input-field col s12 m3">
            <input id="input_os" type="number" step="1" v-model="filtro.os" :data-value="filtro.os">
            <label for="input_os">OS</label>
          </div>

          <div class="input-field col s12 m3">
            <input id="input_venda" type="number" step="1" v-model="filtro.venda" :data-value="filtro.venda">
            <label for="input_venda">Venda</label>
          </div>

        </div>

        <div class="row" v-show="show.filtro && showBtNovo">

          <div class="col s12 m3">
            <label for="filtro_operacao">Operação</label>
            <select name="operacao" id="filtro_operacao" v-model="filtro.operacao">
              <option value="">Todas</option>
              <option value="1">Entrada</option>
              <option value="2">Saída</option>
            </select>
          </div>

          <div class="col s12 m3">
            <label for="filtro_viatura">Viatura</label>
            <select name="viatura" id="filtro_viatura" v-model="filtro.viatura">
              <option v-for="viatura in viaturas" :value="viatura.id">{{ (viatura.id) ? viatura.viatura : 'Todas' }}</option>
            </select>
          </div>

          <div class="col s12 m3">
            <label for="filtro_usuario">Usuário</label>
            <select name="usuario" id="filtro_usuario" v-model="filtro.usuario">
              <option v-for="usuario in usuarios" :value="usuario.id">{{ (usuario.id) ? usuario.nome_completo : 'Todos' }}</option>
            </select>
          </div>

          <div class="input-field col s12 m2">
            <button class="waves-effect waves-light btn"><i class="material-icons left">filter_list</i> Filtrar</button>
            <label></label>
          </div>

          <div class="input-field col s12 m2">
            <button type="button" @click="submitForm()" class="btn">Relatório</button>
            <label></label>
          </div>

        </div>

      </form>

      <div class="row">
        <div class="col s12">
          <router-view @update-estoque-list="updateList"/>
        </div>
      </div>

      <div class="center-align" v-show="showBtNovo && !hasItens && !loading">
        <p>Nenhum registro encontrado!</p>
      </div>

      <div class="row z-depth-1" v-show="showBtNovo && hasItens">
        <div class="col s12">
          <table class="responsive-table bordered highlight">
            <thead>
            <tr>
              <th>#</th>
              <th>Data</th>
              <th>Produto</th>
              <th>Operação</th>
              <th>Qtd</th>
              <th>R$ Unitário</th>
              <th>R$ Total</th>
              <th>Usuário</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="estoque in list">
              <td>
                <router-link :to="{ name: 'estoque.form', params: { id: estoque.id } }" v-if="permissoes.indexOf('estoque.editar') > -1">
                  {{ estoque.id }}
                </router-link>
                <span v-else>{{ estoque.id }}</span>
                <br/>
              </td>
              <td>{{ formatDate(estoque.created_at) }}</td>
              <td>{{ estoque.produto ? estoque.produto.produto : '-' }}<br /><small>{{ estoque.obs }} / {{ estoque.viatura ? estoque.viatura.viatura : '-'}}</small></td>
              <td>{{ estoque.operacao == 1 ? 'Entrada' : 'Saída' }}</td>
              <td>{{ estoque.quantidade }}</td>
              <td>{{ parseFloat(estoque.valor).toFixed(2) }}</td>
              <td>{{ parseFloat(estoque.valor*estoque.quantidade).toFixed(2) }}</td>
              <td>{{ estoque.usuario ? estoque.usuario.nome_completo : '-' }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="row" v-show="showBtNovo && hasItens">
        <div class="col s12 center-align">
          <paginate
            :page-count='pagination.last_page'
            :click-handler="paginate"
            :prev-text="'chevron_left'"
            :next-text="'chevron_right'"
            :container-class="'pagination'"
            :page-class="'waves-effect'"
            :prev-class="'material-icons'"
            :next-class="'material-icons'"
            :force-page='pagination.current_page-1'
          >
          </paginate>
        </div>
      </div>

    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/features/produtos/estoque/index.vue